import {faPlay} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Image, Skeleton} from 'antd';
import {useMemo} from 'react';

import {useDomainConfig} from '../../../../../../../provider/domain-config/domain-config-hook';
import {classNames} from '../../../../../../../util/css';
import {getReviewVideoPreviewDisplaySrc} from '../../../../review-embed-video-helper';
import {PREVIEW_IMAGE_PLACEHOLDER_SRC} from '../../../../review-preview-video';
import {useReviewEmbedVideo} from '../../../../use-review-embed-video-hook';

import * as styles from './preview-group.scss';

type PropsType = {
    imageClassName?: string;
    onClick: () => void;
    poster: string | null;
    videoSrc: string;
};

export function PreviewGroupVideoTile(props: PropsType): JSX.Element {
    const {imageClassName, onClick, poster, videoSrc} = props;
    const {domainName} = useDomainConfig();
    const {isIframePlaceholder, isPreviewLoading, previewSrc, showDirectVideoMetadataOverlay} = useReviewEmbedVideo({
        placeholderSrc: PREVIEW_IMAGE_PLACEHOLDER_SRC,
        poster,
        videoUrl: videoSrc,
    });

    const displayPreviewSrc = useMemo(() => {
        if (isIframePlaceholder) {
            return previewSrc;
        }

        return getReviewVideoPreviewDisplaySrc({domainName, src: previewSrc});
    }, [domainName, isIframePlaceholder, previewSrc]);

    return (
        <div
            className={styles.ImageGallery_videoTile}
            onClick={onClick}
            onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onClick();
                }
            }}
            role="button"
            tabIndex={0}
        >
            {isPreviewLoading ? (
                <Skeleton.Image active />
            ) : (
                <Image
                    alt=""
                    className={classNames(
                        styles.ImageGallery_image,
                        styles.ImageGallery_videoThumbnail,
                        imageClassName,
                        {
                            [styles.ImageGallery_videoThumbnailPlaceholder]: isIframePlaceholder,
                        }
                    )}
                    preview={false}
                    src={displayPreviewSrc}
                />
            )}
            {showDirectVideoMetadataOverlay && (
                <video
                    className={styles.ImageGallery_videoThumbnailOverlay}
                    muted
                    playsInline
                    preload="metadata"
                    src={videoSrc}
                />
            )}
            <Button className={styles.ImageGallery_videoPlayButton} tabIndex={-1} type="text">
                <FontAwesomeIcon className={styles.ImageGallery_videoPlayIcon} icon={faPlay} />
            </Button>
        </div>
    );
}
